import { ActivityProducts } from './activity-products'

export { ActivityProducts } from './activity-products'

export default ActivityProducts
